import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './modules/Modules.css';
import { useDynamicSEO } from '../hooks/useSEO';
import { useLanguage } from '../i18n/LanguageContext';
import { AdBanner, AdSideRails, SLOT_MODULE_BOTTOM } from './ads/Ads';
import DictationModule from './modules/DictationModule';
import ReciteModule from './modules/ReciteModule';
import WritingGradedModule from './modules/WritingGradedModule';
import UnderstandingModule from './modules/UnderstandingModule';
import ExamModule from './modules/ExamModule';
import NotesModule from './modules/NotesModule';
import ListeningModule from './modules/ListeningModule';
import LectureModule from './modules/LectureModule';
const SpeakingModuleLazy = React.lazy(() => import('./modules/SpeakingModule'));

const ModulePage: React.FC = () => {
  const { moduleId } = useParams<{ moduleId: string }>();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const getModuleTitle = (moduleId: string): string => {
    const moduleConfig: Record<string, string> = {
      dictation: 'Dictation Practice - StudyMind | Free Listen & Write Drill (No AI)',
      recite: 'Flashcards - StudyMind | AI-Generated Smart Flashcards',
      exam: 'Practice Exams - StudyMind | AI-Generated Test Questions',
      writing: 'Writing Feedback - StudyMind | AI Writing Assessment & Grading',
      notes: 'Study Notes - StudyMind | AI-Generated Learning Notes',
      understanding: 'Understanding Chat - StudyMind | AI Learning Assistant',
      listening: 'Listening Practice - StudyMind | Audio Learning & Assessment',
      speaking: 'Speaking Practice - StudyMind | AI Speaking Coach',
      lecture: 'Lecture Module - StudyMind | AI-Powered PDF Lecture Processing',
    };
    return moduleConfig[moduleId as string] || 'StudyMind | AI-Powered Learning Platform';
  };

  useDynamicSEO(moduleId ? getModuleTitle(moduleId) : 'StudyMind | AI-Powered Learning Platform');

  const handleBackClick = () => navigate('/app');

  const renderModule = () => {
    switch (moduleId) {
      case 'dictation':
        return <DictationModule />;
      case 'recite':
        return <ReciteModule />;
      case 'writing':
        return <WritingGradedModule />;
      case 'understanding':
        return <UnderstandingModule />;
      case 'exam':
        return <ExamModule />;
      case 'notes':
        return <NotesModule />;
      case 'listening':
        return <ListeningModule />;
      case 'lecture':
        return <LectureModule />;
      case 'speaking':
        return (
          <React.Suspense fallback={<div className="status-message info">Loading...</div>}>
            <SpeakingModuleLazy />
          </React.Suspense>
        );
      default:
        return (
          <div className="error-container">
            <h2>Module Not Found</h2>
            <p>The requested module could not be found.</p>
            <button onClick={handleBackClick} className="btn btn-primary">
              Back to Modules
            </button>
          </div>
        );
    }
  };

  return (
    <div className="module-page">
      {/* Fixed skyscraper rails pinned to the screen edges (wide screens only);
          they are overlays, so module content is never compressed. */}
      <AdSideRails />
      <div className="module-page-header">
        <button className="back-button" onClick={handleBackClick}>
          {t('common.backToModules')}
        </button>
      </div>
      {renderModule()}
      <AdBanner label="module-bottom" slot={SLOT_MODULE_BOTTOM} leaderboard style={{ margin: '24px auto 0' }} />
    </div>
  );
};

export default ModulePage;
